/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/styles/padding
 */
import { getPositionShorthandNormalizer, getBoxSidesValueReducer } from './utils';
/**
 * Adds a margin CSS styles processing rules.
 *
 *		editor.data.addStyleProcessorRules( addPaddingRules );
 *
 * The normalized value is stored as:
 *
 *		const styles = {
 *			padding: {
 *				top,
 *				right,
 *				bottom,
 *				left
 *			}
 *		};
 *
 * @param {module:engine/view/stylesmap~StylesProcessor} stylesProcessor
 */

export function addPaddingRules(stylesProcessor) {
  stylesProcessor.setNormalizer('padding', getPositionShorthandNormalizer('padding'));
  stylesProcessor.setNormalizer('padding-top', function (value) {
    return {
      path: 'padding.top',
      value: value
    };
  });
  stylesProcessor.setNormalizer('padding-right', function (value) {
    return {
      path: 'padding.right',
      value: value
    };
  });
  stylesProcessor.setNormalizer('padding-bottom', function (value) {
    return {
      path: 'padding.bottom',
      value: value
    };
  });
  stylesProcessor.setNormalizer('padding-left', function (value) {
    return {
      path: 'padding.left',
      value: value
    };
  });
  stylesProcessor.setReducer('padding', getBoxSidesValueReducer('padding'));
  stylesProcessor.setStyleRelation('padding', ['padding-top', 'padding-right', 'padding-bottom', 'padding-left']);
}